import { baseApi } from '../../../../core/data/rtk/baseQuery';
import { ApiResponseType } from '../../../../core/data/rtk/apiResponseType';
import { SessionResponseType, Data } from '../types/sessionResponse';
import { SessionPayloadType } from '../types/sessionRequest';

export const centerApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllSessions: builder.query<ApiResponseType<Data>, { size?: number; search?: string, page?:number }>({
            query: (params) => {
                const queryParams = new URLSearchParams();
                if (params?.size) queryParams.append('size', params.size.toString());
                if (params?.search) queryParams.append('search', params.search);
                if (params?.page) queryParams.append('page', params.page.toString());
                
                return `academic-sessions/get-all?${queryParams.toString()}`;
            },
            providesTags: ['Sessions'],
        }),
        addSession: builder.mutation<ApiResponseType<{academicSession: SessionResponseType}>, SessionPayloadType>({
            query: (payload) => ({
                url: 'academic-sessions/save',
                method: 'POST',
                body: payload
            }),
            invalidatesTags: ['Sessions'],
        }),
        getSessionById: builder.query<ApiResponseType<{ academicSession: SessionResponseType }>, { id: string }>({
            query: ({ id }) => `academic-sessions/get/${id}`,
            providesTags: ['Sessions'],
        }),
        updateSession: builder.mutation<ApiResponseType<{ academicSession: SessionResponseType }>, { id: string; payload: SessionPayloadType }>({
            query: ({ id, payload }) => ({
                url: `academic-sessions/update/${id}`,
                method: 'PUT',
                body: payload
            }),
            invalidatesTags: ['Sessions'],
        }),
        deleteSession: builder.mutation<ApiResponseType<{ deleted: true }>, { id: string }>({
            query: ({ id }) => ({
                url: `academic-sessions/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Sessions'],
        }),
    }),
});

export const { 
    useGetAllSessionsQuery,
    useAddSessionMutation,
    useGetSessionByIdQuery,
    useUpdateSessionMutation,
    useDeleteSessionMutation
} = centerApi;